<article class="notice-card notice-card--critical" [attr.data-status]="content.notificationStatus" role="alert" aria-live="polite">
  <div class="notice-card__content">
    <div class="notice-card__title">{{ content.title }}</div>
    <div class="notice-card__text">{{ content.message }}</div>
  </div>
</article>